import React from 'react';
import App from 'next/app';
import Script from 'next/script';
import { DFPSlotsProvider } from 'react-dfp';
import { withBlaze } from '@blaze-cms/nextjs-tools';
import { ApolloProvider } from '@apollo/client';
import { ResponsiveImageProvider } from '@blaze-cms/image-cdn-react';
import { ToastProvider } from '@blaze-react/toaster';
import buildConfig from '../blaze.config';
import IndexPage from '../components/IndexPage';
import Footer from '../components/Footer';
import { PROJECT_NAME, RESPONSIVE_IMAGE_CONFIG, DFP_LAZY_LOAD_CONFIG } from '../constants';
import '../styles/sass/main.scss';
// import '../styles/globals.css';

const DFP_DISABLE_INITIAL_LOAD =
  typeof window !== 'undefined'
    ? localStorage.getItem('DFP_DISABLE_INITIAL_LOAD') === 'true'
    : true;

class MyApp extends App {
  render() {
    const {
      props: { Component, pageProps, apolloClient, router }
    } = this;

    return (
      <>
        <Script id="gtm-blaze_after_interactive_event" strategy="afterInteractive">{`
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
           'event': 'blaze_after_interactive'
          });
        `}</Script>
        <ApolloProvider client={apolloClient}>
          <DFPSlotsProvider
            dfpNetworkId={process.env.DFP_NETWORK_ID}
            singleRequest={false}
            lazyLoad={DFP_LAZY_LOAD_CONFIG}
            disableInitialLoad={DFP_DISABLE_INITIAL_LOAD}
            collapseEmptyDivs>
            <ToastProvider>
              <ResponsiveImageProvider config={RESPONSIVE_IMAGE_CONFIG}>
                <IndexPage />
                <div
                  className={`site-container page-type-selector--${(pageProps || {}).itemEntity}`}>
                  <main className="main">
                    <Component {...pageProps} router={router} projectName={PROJECT_NAME} />
                  </main>
                  <Footer />
                </div>
              </ResponsiveImageProvider>
            </ToastProvider>
          </DFPSlotsProvider>
        </ApolloProvider>
      </>
    );
  }
}
export default withBlaze(MyApp, buildConfig);
